import React from 'react';
import {
    BoxMarginProps,
    StepInnerActive,
    StepInnerDefault,
    StepLineActive,
    StepLineDefault,
    StepOuterActive,
    StepOuterDefault,
    StepsRoot,
} from './styles';

export type GivelifyStepsProps = BoxMarginProps & {
    steps: number;
    current?: number;
    className?: string;
    variant: 'vertical' | 'horizontal';
    onClick?: (index: number) => void;
};

export type StepBaseProps = {
    value: number;
    done: boolean;
    variant: 'vertical' | 'horizontal';
    active?: boolean;
    onClick?: () => void;
};

export const StepBaseCircle: React.FC<StepBaseProps> = ({
    done,
    value,
    active = false,
    onClick,
}) => {
    const OutDiv = active ? StepOuterActive : StepOuterDefault;
    const InnerDiv = done ? StepInnerActive : StepInnerDefault;
    return (
        <OutDiv key={`gvl-step-${value}`}>
            <InnerDiv
                disabled={!done || active}
                onClick={onClick}
                tabIndex={-1}
            >
                {value}
            </InnerDiv>
        </OutDiv>
    );
};

export const StepBaseKnot: React.FC<StepBaseProps> = ({
    value,
    active = false,
    variant,
}) => {
    const Knot = active ? StepLineActive : StepLineDefault;
    return <Knot key={`gvl-step-kn-${value}`} variant={variant} />;
};

export const StepsBase: React.FC<GivelifyStepsProps> = ({
    steps,
    current: passedCurrent = -1,
    margin,
    marginBottom,
    marginLeft,
    marginRight,
    marginTop,
    className,
    variant,
    onClick,
}) => {
    const current = passedCurrent - 1;
    if (steps <= 0) return null;
    const stepComps = [];
    let knotCount = 0;
    for (let index = 0; index < steps; index++) {
        if (index !== 0) {
            stepComps.push(
                StepBaseKnot({
                    value: knotCount,
                    done: index <= current,
                    variant,
                }),
            );
            knotCount++;
        }
        stepComps.push(
            StepBaseCircle({
                value: index + 1,
                done: index <= current,
                active: index === current,
                variant,
                onClick: onClick
                    ? () => {
                          onClick(index);
                      }
                    : undefined,
            }),
        );
        if (index + 1 < steps) {
            stepComps.push(
                StepBaseKnot({
                    value: knotCount,
                    done: index <= current,
                    variant,
                }),
            );
            knotCount++;
        }
    }
    return (
        <StepsRoot
            childCount={3 * steps - 2}
            className={className}
            margin={margin}
            marginBottom={marginBottom}
            marginLeft={marginLeft}
            marginRight={marginRight}
            marginTop={marginTop}
            variant={variant}
        >
            {stepComps.map((item) => item)}
        </StepsRoot>
    );
};
